<div class="top-bar position-fixed">
    <div class="row align-items-center">
        <div class="col-2">
            <a class="platform-logo-container">
                <ng-container *ngIf="currentThemeStore.currentTheme$ | async">
                    <img [src]="logoSrc" alt="WuDo Platform" class="platform-logo" />
                </ng-container>
            </a>
        </div>
    </div>
</div>

<div class="main-container w-100">
    <div style="max-width: 1000px; margin: auto; display: flex; align-items: stretch" class="p-mt-4">
        <div style="width: 60%">
            <div class="row">
                <app-step-progress-bar class="p-col-6" #stepProgressBar [progress]="step"></app-step-progress-bar>
            </div>

            <div style="min-height: 456.6px" class="p-pr-4 p-pl-4">
                <!-- step 1 : user personal infos -->
                <app-onboarding-user-infos *ngIf="step === 1" @fadeInOut></app-onboarding-user-infos>

                <!-- step 2 : user skills -->
                <app-onboarding-user-skills *ngIf="step === 2" @fadeInOut></app-onboarding-user-skills>

                <!-- step 3 : user interests -->
                <app-onboarding-user-interests *ngIf="step === 3" @fadeInOut></app-onboarding-user-interests>

                <!-- step 4 : user about me -->
                <app-onboarding-user-completion *ngIf="step === 4" @fadeInOut (completed)="goToHomePage($event)">
                </app-onboarding-user-completion>
            </div>
            <div class="p-pr-4 p-pl-4 button-container">
                <div class="text-left">
                    <button class="p-button p-button-secondary" *ngIf="step === 2 || step === 3" (click)="skipStep()">
                        {{ 'components.button.skip' | translate }}
                    </button>
                </div>
                <div class="text-right">
                    <button *ngIf="step > 1" class="p-button p-button-outlined p-mr-1" (click)="onPreviousStep()">
                        {{ 'components.button.buttonPrevious' | translate }}
                    </button>
                    <p-button
                        *ngIf="step < 4"
                        label="{{ 'components.button.buttonNext' | translate }}"
                        [loading]="isLoading"
                        icon="pi pi-angle-right"
                        iconPos="right"
                        (onClick)="onNextStep()"
                    ></p-button>
                    <p-button
                        *ngIf="step === 4"
                        label="{{ 'components.button.finish' | translate }}"
                        [loading]="isLoading"
                        iconPos="right"
                        (onClick)="completeOnboarding()"
                    >
                    </p-button>
                </div>
            </div>
        </div>

        <div class="container" style="width: 40%; background-color: #ffd390">
            <app-onboarding-community-members></app-onboarding-community-members>
        </div>
    </div>
</div>
